import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const AllHeaderComponent = React.lazy(() => import("../Components/RootComponents/AllHeaderComponent"));
const AllHeaderPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <AllHeaderComponent />
      </Suspense>
    </Fragment>
  );
};

export default AllHeaderPage;
